import React, {Suspense} from "react";
import * as ReactDOM from "react-dom";
import ErrorBoundary from "../../utils/ErrorBoundary";
// import LookOverview from "./LookOverview";

const LookOverview = React.lazy(() => import(/* webpackPrefetch: true */ "./LookOverview"));

const LookOverviewPortal = () => {
  const lookOverviewDiv = document.body.querySelector<HTMLElement>("#shop-the-look-overview > div");

  if (!lookOverviewDiv) {
    return null;
  }

  const preloader = lookOverviewDiv.getElementsByClassName("swiper-lazy-preloader")[0];
  if (preloader) lookOverviewDiv.removeChild(preloader);

  return ReactDOM.createPortal(
    <ErrorBoundary fallback={null} occurrence="LookDetail">
      <Suspense fallback={null}>
        <LookOverview />
      </Suspense>
    </ErrorBoundary>,
    lookOverviewDiv,
  );
};

export default LookOverviewPortal;
